import React, { useCallback, useEffect } from 'react'

import { Col, Span } from 'components'
import { LoadingIcon } from 'components/Icons'
import { useAuth, useLoading, useModal } from 'hooks'
import jwt from 'jsonwebtoken'
import { Header } from 'pages/Login/components/Header/Header'
import { useHistory, useParams } from 'react-router-dom'
import { UserSupplierServices } from 'services/Supplier/Users'
import { COLORS, SPACING } from 'utils'

interface IParam {
  token: string
}
const AcessEmail: React.FC = () => {
  const { setLoading } = useLoading()
  const { token } = useParams<IParam>()
  const { push } = useHistory()
  const { showModal } = useModal()
  const {
    setUser,
    setAllData,
    setUsuarioCsn,
    setUsuarioFornecedor,
    setIsLogged,
    setToken,
    handleLogin
  } = useAuth()

  const cleanUserAndSetErrorMessage = (message: string) => {
    setLoading('idle')
    setToken(null)
    setIsLogged(false)
    showModal({
      handleConfirm: () => push('/'),
      hideButtonCancel: true,
      message: message,
      type: 'error'
    })
  }

  const handleLoginAcessEmail = useCallback(async () => {
    setLoading('loading')
    try {
      const descripted = jwt.decode(token)

      const usuarioFornecedorExists = await UserSupplierServices().getByEmail(
        descripted.login,
        token
      )

      if (usuarioFornecedorExists.data === null) {
        cleanUserAndSetErrorMessage('Não foi possivel encontrar o usuario!')
        return
      }

      if (usuarioFornecedorExists.data && !usuarioFornecedorExists.data?.flPrimeiroAcesso) {
        cleanUserAndSetErrorMessage('Usuario já realizou primeiro acesso!')
        return
      }

      try {
        handleLogin({
          email: descripted.login,
          isCsn: false,
          password: descripted.password,
          rememberMe: true
        })
        setLoading('idle')
      } catch (loginError) {
        console.error('Erro no login:', loginError)
        cleanUserAndSetErrorMessage('Erro na autenticação do usuário')
      }
    } catch (error: any) {
      cleanUserAndSetErrorMessage(
        'Não foi possivel entrar no sistema, tente novamente'
      )
    }
  }, [token])

  useEffect(() => {
    setUser(null)
    setAllData(null)
    setUsuarioCsn(null)
    setUsuarioFornecedor(null)
    handleLoginAcessEmail()
  }, [handleLoginAcessEmail])

  return (
    <>
      <Header />
      <Col
        alignItems="center"
        justifyContent="center"
        marginTop={SPACING.spacing50}
      >
        <LoadingIcon colorIcon={COLORS.blueFonts} />
        <Span text="Autenticando acesso." />
      </Col>
    </>
  )
}

export default AcessEmail
